<template>
    <div :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
        <page-navigate></page-navigate>
        <div class="EAHeader flex box-border">
            <div class="EAHeaderMain">
                <h1 class="EATitle super_large-72_bold md-title-32_bold word1">
                    分析工具与指标
                </h1>
                <h2 class="EADesc subtitle-20_regular md-body-14_regular word2">
                    EBC 独家精选的 MT4 / MT5 指标和独创分析工具，助您提升决策精准度和优化账户表现
                </h2>
                 <a :href="signupUrl" target="_blank" class="toolsBtn primary-default_large cursor-pointer">
            <span class="word4">开始交易</span>
            <span class="iconfont icon-right"></span>
        </a>
            </div>
            <img src="@/assets/image/tools/EAContainer1.png?t=1" alt="" class="EAHeaderModel" />
        </div>
           <div class="EAAdChart">
      <div class="contentBox">
      <h2 class="scroll-fade-up  title-48_bold md-title-24_bold">TradingView高级图表</h2>
      <div class="scroll-fade-up subtitle-20_regular md-footnote-regular_12 EAAdChartDesc">多图表并行、高级技术指标和强大绘图功能，全方位剖析市场趋势</div>
      <img class="scroll-fade-up EAAdChartModel" src="@/assets/image/tools/section2NewModel.png" alt="" />
      <div class="EAAdChartList flex items-center scroll-fade-up">
        <div>
          <img src="@/assets/image/tools/section2NewLogo1.webp" alt="">
          <div class="subtitle-20_medium md-subtitle-18_medium EAAdChartListTitle">多图表并行</div>
          <div class="body-14_regular md-footnote-regular_12">同屏查看多个图表，提升分析效率</div>
        </div>
        <div>
          <img src="@/assets/image/tools/section2NewLogo2.webp" alt="">
          <div class="subtitle-20_medium md-subtitle-18_medium EAAdChartListTitle">高级技术指标</div>
          <div class="body-14_regular md-footnote-regular_12">免费解锁高级和自定义指标</div>
        </div>
        <div>
          <img src="@/assets/image/tools/section2NewLogo3.webp" alt="">
          <div class="subtitle-20_medium md-subtitle-18_medium EAAdChartListTitle">绘图工具</div>
          <div class="body-14_regular md-footnote-regular_12">使用14类超100种工具，直观分析趋势形态</div>
        </div>
      </div>
      <a :href="signupUrl" target="_blank" class="EAAdChartBtn scroll-fade-up primary-default_large">立即体验</a>
    </div>
    </div>
        <div class="EAAnalyze">
            <div class="contentBox">
                <div class="EAAnalyzeCardList flex scroll-fade-up">
                    <div class="EAAnalyzeCard">
                        <img src="@/assets/image/tools/EALogo1.svg" alt="" />
                        <div class="body-14_regular md-body-14_reguar word3">
                            EBC Turbo账户分析系统，深度解析交易表现，优化投资策略。
                        </div>
                        <div class="splitLine pc"></div>
                    </div>
                    <div class="EAAnalyzeCard">
                        <img src="@/assets/image/tools/EALogo2.svg" alt="" />
                        <div class="body-14_regular md-body-14_medium word4">
                            实用型技术指标集，掌握市场脉动，把握最佳交易时机。
                        </div>
                    </div>

                </div>
                <h2 class="title-48_bold md-title-24_bold EAAnalyzeTitle text-center scroll-fade-up word5">
                    账户分析系统
                </h2>
                <h3 class="subtitle-20_regular md-footnote-regular_12 EAAnalyzeDesc text-center scroll-fade-up word6">
                    EBC独家盈亏统计和历史回溯工具，基于多维评价系统与深度嵌入模型，全面解析交易细节，助力优化交易策略
                </h3>
                <div class="EAAnalyzeToolsSwiper scroll-fade-up">
                    <div class="EAAnalyzeToolsCardList  swiper-wrapper flex">
                        <div class="EAAnalyzeToolsCard  swiper-slide">
                            <div class="EAAnalyzeToolsImg">
                                <div class="EAAnalyzeToolsImgWithWord">
                                    <div class="footnote-regular_12 word7">收益率</div>
                                    <div class="EAAnalyzeToolsImgWithWordCenter">
                                        <div class="EAAnalyzeToolsImgCenterLeft">
                                            <div class="EAAnalyzeToolsImgCenterWordTop footnote-regular_12 word8">
                                                最大回撤
                                            </div>
                                            <div class="EAAnalyzeToolsImgCenterWordBottom footnote-regular_12 word9">
                                                收益波动率
                                            </div>
                                        </div>
                                        <img src="@/assets/image/tools/EAAnalyzeToolImg1.png" alt="" />
                                        <div class="EAAnalyzeToolsImgCenterRight">
                                            <div class="EAAnalyzeToolsImgCenterWordTop footnote-regular_12 word10">
                                                获利系数
                                            </div>
                                            <div class="EAAnalyzeToolsImgCenterWordBottom footnote-regular_12 word11">
                                                风险回报比
                                            </div>
                                        </div>
                                    </div>
                                    <div class="footnote-regular_12 word12">盈利交易（胜率）</div>
                                </div>
                            </div>
                            <div class="subtitle-20_medium md-body-16_medium EAAnalyzeToolsName text-center word13">
                                六维评级图
                            </div>
                        </div>
                        <div class="EAAnalyzeToolsCard swiper-slide">
                            <div class="EAAnalyzeToolsImg">
                                <img src="@/assets/image/tools/EAAnalyzeToolImg2.png" alt="" />
                            </div>
                            <div class="subtitle-20_medium md-body-16_medium EAAnalyzeToolsName text-center word14">
                                每日/月度统计
                            </div>
                        </div>
                        <div class="EAAnalyzeToolsCard swiper-slide">
                            <div class="EAAnalyzeToolsImg">
                                <img src="@/assets/image/tools/EAAnalyzeToolImg3.png" alt="" />
                            </div>
                            <div class="subtitle-20_medium md-body-16_medium EAAnalyzeToolsName text-center word15">
                                资金曲线图
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mobile scroll-fade-up">
                    <div class="EAAnalyzeToolsCardPagenavition flex items-center justify-center">
                        <div class="active"></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <a :href="signupUrl" target="_blank"
                    class="EAAnalyzeToolsBtn primary-default_large scroll-fade-up cursor-pointer word16">立即使用</a>
            </div>
        </div>
        <div class="EAOrderAnaly">
            <h2 class="scroll-fade-up title-48_bold md-title-24_bold  text-center">
                订单流分析法
            </h2>
            <h3 class="subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up">通过盘口数据发现主力隐藏行为</h3>
            <div class="EAOrderAnalyCardList flex justify-center items-center scroll-fade-up">
                <div class="EAOrderAnalyCard">
                    <img src="@/assets/image/tools/orderAnalyModel1.png" alt="">
                    <div class="EAOrderAnalyTitle title-24_bold subtitle-20_bold text-center">40,000+</div>
                    <div class="EAOrderAnalyDesc body-14_regular text-center word19">全球专业用户选择</div>
                </div>
                <div class="EAOrderAnalyCard">
                    <img src="@/assets/image/tools/orderAnalyModel2.png" alt="">
                    <div class="EAOrderAnalyTitle title-24_bold subtitle-20_bold text-center">NO.1</div>
                    <div class="EAOrderAnalyDesc body-14_regular text-center word20">对冲基金最热门分析工具</div>
                </div>
                <div class="EAOrderAnalyCard">
                    <img src="@/assets/image/tools/orderAnalyModel3.png" alt="">
                    <div class="EAOrderAnalyTitle title-24_bold subtitle-20_bold text-center">NO.1</div>
                    <div class="EAOrderAnalyDesc body-14_regular text-center word21">《期货》2019最受欢迎分析技术</div>
                </div>
            </div>
            <a :href="signupUrl" target="_blank"
                class="EAOrderAnalyBtn primary-default_large cursor-pointer scroll-fade-up word22">立即领取</a>
        </div>
        <div class="EATech">
            <div class="EATechTitle title-48_bold md-title-24_bold  text-center scroll-fade-up word23">实用型技术指标集</div>
            <div class="EATechDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up word24">
                经过优化的常用技术指标，支持多角度市场分析与自定义配置，帮助用户精确判断市场动向</div>
            <div class="EATechList flex items-center scroll-fade-up">
                <div class="EATechWordContainer">

                    <div class="EATechWord cursor-pointer active">
                        <div class="EATechWordTitle subtitle-20_regular md-subtitle-20_medium word25">同图商品叠加工具</div>
                        <div class="EATechWordDesc body-16_regular md-content-14_regular word26">
                            通过叠加两个商品的走势，对比分析相对强弱和形态差异，识别关键突破点</div>
                    </div>
                    <div class="EATechWord cursor-pointer">
                        <div class="EATechWordTitle subtitle-20_regular md-subtitle-20_medium word27">MACD专业指标(双线)</div>
                        <div class="EATechWordDesc body-16_regular md-content-14_regular word28">
                            提供比普通MACD更为精准的双线指标，更好地识别市场的买卖信号</div>
                    </div>
                    <div class="EATechWord cursor-pointer">
                        <div class="EATechWordTitle subtitle-20_regular md-subtitle-20_medium word29">MTDriver盈亏统计指标
                        </div>
                        <div class="EATechWordDesc body-16_regular md-content-14_regular word30">
                            该指标可协助投资者实时统计不同周期内的盈亏情况，为制定更精准的交易策略提供数据支持</div>
                    </div>
                    <div class="EATechWord cursor-pointer">
                        <div class="EATechWordTitle subtitle-20_regular md-subtitle-20_medium word31">价格变动手机推送通知</div>
                        <div class="EATechWordDesc body-16_regular md-content-14_regular word32">
                            实时监控市场价格波动，并在重大变动时发送预警通知</div>
                    </div>
                </div>
                <div class="swiper EATechImgSwiper">
                    <div class="EATechImg swiper-wrapper">
                        <img src="@/assets/image/tools/EATechWord1.png" alt="" class="swiper-slide active">
                        <img src="@/assets/image/tools/EATechWord2.png" alt="" class="swiper-slide">
                        <img src="@/assets/image/tools/EATechWord3.png" alt="" class="swiper-slide">
                        <img src="@/assets/image/tools/EATechWord4.png" alt="" class="swiper-slide">
                    </div>
                </div>
            </div>
            <div class="mobile scroll-fade-up">
                <div class="EATechListPagenavition flex items-center justify-center">
                    <div class="active"></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>

            <a :href="signupUrl" target="_blank"
                class="EATechBtn primary-default_large cursor-pointer scroll-fade-up word33">获取指标</a>
        </div>
        <div class="EACalculate">
            <h2 class="EACalculateTitle title-48_bold md-title-24_bold  text-center scroll-fade-up word34">计算每一笔交易</h2>
            <h3 class="EACalculateDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up word35">
                多款实用计算器，帮你在下单前快速量化风险与机会</h3>
            <a href="/forex-tools/"
                class="EACalculateBtn flex justify-between items-center cursor-pointer scroll-fade-up">
                <span class="word36">更多计算器</span>
                <span class="iconfont icon-right"></span>
            </a>
            <div class="EACalculateList flex justify-center scroll-fade-up">
                <a href="/forex-tools/pivot-points-calculator/ " class="EACalculateItem">
                    <img src="@/assets/image/tools/EACalculateItem1.svg" alt="">
                    <div class="subtitle-18_medium EACalculateItemTitle md-body-16_medium word51">Pivot Points计算器</div>
                    <div class="body-14_regular EACalculateItemDesc word52">此枢轴点计算器可在几秒钟内生成4种不同系统的枢轴点！帮您计算出多种枢轴点和支撑/阻力水平
                    </div>
                    <div class="EACalculateItemBtn secondary-default_medium word37">立即查看</div>
                    <span class="iconfont icon-right mobile"></span>
                </a>
                <a href="/forex-tools/fibonacci-calculator/ " class="EACalculateItem">
                    <img src="@/assets/image/tools/EACalculateItem2.svg" alt="">
                    <div class="subtitle-18_medium EACalculateItemTitle md-body-16_medium word53">斐波那契计算器</div>
                    <div class="body-14_regular EACalculateItemDesc word54">
                        斐波那契计算器可帮助您计算4种基本的斐波纳契回撤值。帮您计算已完结趋势的回撤水平。将改善您的外汇交易经历并可使您全时参与外汇市场。</div>
                    <div class="EACalculateItemBtn secondary-default_medium word37">立即查看</div>
                    <span class="iconfont icon-right mobile"></span>

                </a>
                <a href="/forex-tools/pip-value-calculator/ " class="EACalculateItem">
                    <img src="@/assets/image/tools/EACalculateItem3.svg" alt="">
                    <div class="subtitle-18_medium EACalculateItemTitle md-body-16_medium word55">点值计算器</div>
                    <div class="body-14_regular EACalculateItemDesc word56">
                        如果您想知道任何外汇交易货币的单个点的价格，请使用此点值计算器。在处理许多或异国货币对时，使用这个免费的外汇工具来计算和计划您的订单。您需要做的就是填写下面的表格，然后按“计算”按钮：
                    </div>
                    <div class="EACalculateItemBtn secondary-default_medium word37">立即查看</div>
                    <span class="iconfont icon-right mobile"></span>

                </a>
                <a href="/forex-tools/position-size-calculator/ " class="EACalculateItem">
                    <img src="@/assets/image/tools/EACalculateItem4.svg" alt="">
                    <div class="subtitle-18_medium EACalculateItemTitle md-body-16_medium word57">头寸规模计算器</div>
                    <div class="body-14_regular EACalculateItemDesc word58">
                        一个免费的外汇工具，可让您以单位和手数计算头寸大小，以准确管理您的风险。它适用于所有主要货币对和交叉盘。它只需要很少的输入值，但允许您根据您的特定需求对其进行微调。您需要做的就是填写下面的表格，然后按“计算”按钮）
                    </div>
                    <div class="EACalculateItemBtn secondary-default_medium word37">立即查看</div>
                    <span class="iconfont icon-right mobile"></span>

                </a>
                <a href="/forex-tools/risk-reward-calculator/ " class="EACalculateItem">
                    <img src="@/assets/image/tools/EACalculateItem5.svg" alt="">
                    <div class="subtitle-18_medium EACalculateItemTitle md-body-16_medium word59">风险和收益计算器</div>
                    <div class="body-14_regular EACalculateItemDesc word60">
                        风险回报计算器可帮您计算出基于局部峰值和底部的斐波纳契回撤的头寸的最佳目标和各自的风险回报比率。这是一种进场前计算潜在风险的高效的工具。</div>
                    <div class="EACalculateItemBtn secondary-default_medium word37">立即查看</div>
                    <span class="iconfont icon-right mobile"></span>

                </a>
                <a href="/forex-tools/gain-loss-percentage-calculator/ " class="EACalculateItem">
                    <img src="@/assets/image/tools/EACalculateItem6.svg" alt="">
                    <div class="subtitle-18_medium EACalculateItemTitle md-body-16_medium word61">损益百分比计算器</div>
                    <div class="body-14_regular EACalculateItemDesc word62">
                        此在线损益百分比计算器可快速告诉您您赢或输的帐户余额百分比。它还估计了再次达到盈亏平衡点所需的当前余额的百分比。或者，您可以输入百分比并查看货币收益或损失的大小。</div>
                    <div class="EACalculateItemBtn secondary-default_medium word37">立即查看</div>
                    <span class="iconfont icon-right mobile"></span>
                </a>
            </div>
        </div>
        <section class="container4 commonQuestion">
            <div class="contentBox">
                <h2 class="scroll-fade-up word38">常见问题</h2>
                <div class="QA-list">
                    <div class="QA-item">
                        <div class="QA-title word39">1、交易者可以使用哪些交易工具？</div>
                        <div class="QA-content">
                            <p class="QA-li word40">
                                交易工具，可以分为技术指标和账户分析工具。
                                技术指标，是通过研究过去的市场行为图表来预测价格走势和市场趋势；账户分析工具，则是通过评价指标，分析账户盈亏表现，从而实现优化策略和提升盈利表现。
                                EBC交易者可以使用的账户分析工具，包括独创EBC Turbo账户分析系统和MTdriver盈亏统计指标；技术指标方面，EBC提供Trading
                                Central信号和TC技术面分析指标，同时还包括双线MACD和同图叠加工具等实用指标集。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word41">2、哪些交易工具最好？</div>
                        <div class="QA-content">
                            <p class="QA-li word42">
                                许多交易者同时使用不同类型的交易工具，实时发现市场机遇，通过综合研判提升整体策略表现，EBC将市场最实用的顶尖交易工具纳入指标库中，帮助客户取得领先优势。
                                EBC提供的交易工具，包括实用指标集、机构独创指标和交易大师指标等，这些工具均可免费试用，且易于获取。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word43">3、在哪里可以免费获取工具？</div>
                        <div class="QA-content">
                            <p class="QA-li word44">
                                在EBC官网的专区栏目中，可以从EBC指标库中直接调用、下载和获取对应指标和插件，从而规划和优化您的交易。
                                您也可以通过EBC MT4/MT5访问迈达克社区，访问并获取庞大的指标工具库，获取免费工具。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word45">4、如何在MT4/MT5平台上添加自定义指标？</div>
                        <div class="QA-content">
                            <p class="QA-li word46">
                                打开 MT4/MT5，选择“文件”，点击“打开数据文件夹”，然后选择MQL4/5，打开文件夹“Experts”，并将MQL4或MQL5文件黏贴到这个文件夹。
                                当您重新打开平台时，可以在导航窗口中看到您的自定义指标。您可以将其拖放到您选择的图表中。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word47">5、安装后如何调用指标？</div>
                        <div class="QA-content">
                            <p class="QA-li word48">
                                在MT4/MT5平台左侧的“导航”窗口中查看。点击“技术指标”下拉菜单，就可以自由调用所需的指标。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word49">6、如何分析自己的交易？</div>
                        <div class="QA-content">
                            <p class="QA-li word50">
                                EBC Turbo账户分析系统，支持上传交易截图，一键生成分析报价，从最大回撤、夏普比率、盈利系数等六大维度，全面分析账户表现。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <page-footer></page-footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import fadeAnimate from "../mixins/fadeAnimate.js";
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
export default {
    mixins: [fadeAnimate],
    data() {
        return {
        }
    },

    created() {

    },
    mounted() {
        this.initPage();
    },
    methods: {
        initPage() {

            function initPCTechWord() {
                if (window.matchMedia("(max-width:996px)").matches) return;
                let EATechWordActIdx = 0;
                let EATechInterval = null;
                function initInterval() {
                    EATechInterval = setInterval(() => {
                        document
                            .querySelectorAll(".EATechWord")
                        [EATechWordActIdx].classList.remove("active");
                        document
                            .querySelectorAll(".EATechImg img")
                        [EATechWordActIdx].classList.remove("active");
                        EATechWordActIdx++;
                        if (EATechWordActIdx >= 4) {
                            EATechWordActIdx = 0;
                        }
                        setEATechImg(EATechWordActIdx);
                        document
                            .querySelectorAll(".EATechWord")
                        [EATechWordActIdx].classList.add("active");
                    }, 6000);
                }
                initInterval()
                function setEATechImg(idx) {
                    document.querySelectorAll(".EATechImg img")[idx].classList.add("active");
                }
                document.querySelectorAll(".EATechWord").forEach((i, index) => {
                    i.addEventListener("click", function () {
                        i.classList.add("active");
                        document
                            .querySelectorAll(".EATechImg img")
                        [EATechWordActIdx].classList.remove("active");
                        document
                            .querySelectorAll(".EATechWord")
                        [EATechWordActIdx].classList.remove("active");
                        EATechWordActIdx = index;
                        setEATechImg(index);
                        EATechInterval && clearInterval(EATechInterval);
                        initInterval();
                    });
                });
            }
            initPCTechWord();
            if (window.matchMedia("(max-width:996px)").matches) {
                new Swiper(".EATechImgSwiper", {
                    centeredSlides: true,
                    slidesPerView: 1.35,
                    spaceBetween: 16,
                    loop: true,
                    autoplay: {
                        delay: 6000,
                    },
                    on: {
                        slideChange:function() {
                            document.querySelectorAll(".EATechWord").forEach((item, index) => {
                                if (index == this.realIndex) {
                                    item.classList.add("active");
                                } else {
                                    item.classList.remove("active");
                                }
                            });
                            document
                                .querySelectorAll(".EATechListPagenavition div")
                                .forEach((item, index) => {
                                    if (index == this.realIndex) {
                                        item.classList.add("active");
                                    } else {
                                        item.classList.remove("active");
                                    }
                                });
                        },
                    },
                });
                new Swiper(".EAAnalyzeToolsSwiper", {
                    slidesPerView: 1,
                    centeredSlides: false,
                    on: {
                        slideChange:function() {

                            document
                                .querySelectorAll(".EAAnalyzeToolsCardPagenavition div")
                                .forEach((item, index) => {
                                    if (index == this.realIndex) {
                                        item.classList.add("active");
                                    } else {
                                        item.classList.remove("active");
                                    }
                                });
                        },
                    },
                    // loop: true, 

                });
            }


            document.querySelectorAll('.EACalculateItem').forEach(card => {
                if(window.matchMedia("(max-width:996px)").matches) return;
                const btn = card.querySelector('.EACalculateItemBtn');
                const link = card.href;          // 把真正地址先存起来

                card.addEventListener('click', e => {
                    if (!btn.contains(e.target)) {  // 点的是按钮以外的区域
                        e.preventDefault();          // 不跳转
                    }
                });

                btn.addEventListener('click', () => {
                    location.href = link;          // 只有点按钮才走链接
                });
            });
        }
    },
    computed: {

        ...mapGetters([
            'signupUrl',
        ])
    },
}
</script>

<style scoped>
@import url("../assets/css/commonQuestion.scss");
a:hover{
    color: #fff;
}
.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

.EAHeader {
    background-color: var(--ebc-neutral-bg_c);
}

.EAHeader {
    padding-left: calc(50vw - 600rem);
    gap: 77rem;
}

.EAHeaderMain {
    flex: 0 0 588rem;
    margin-top: 160rem;
}

.EADesc {
    color: var(--ebc-text-secondary);
    margin: 24rem 0 64rem;
}

.EAHeaderModel {
    width: 653rem;
    height: 560rem;
}
.toolsBtn{
  min-width: 180rem;
  width: fit-content;
  gap: 5rem;
}
@media (min-width: 996px) {
    .EADesc {
        max-width: 700rem;
    }

    .EACalculateItemBtn:hover {
        color: var(--ebc-text-primary_white) !important;
        background-color: var(--ebc-basecolor-active-500);
    }

    .ar .EAHeader {
        padding-left: unset;
        padding-right: calc(50vw - 600rem);
    }

    .mn .EAHeader,
    .ru .EAHeader,
    .pt .EAHeader,
    .es .EAHeader {
        gap: 0rem
    }

    .ru .EAHeaderMain,
    .mn .EAHeaderMain,
    .pt .EAHeaderMain,
    .es .EAHeaderMain {
        flex: 0 0 755rem;
        position: relative;
        z-index: 2;
    }

    .ru .EAHeaderMain h1,
    .mn .EAHeaderMain h1,
    .pt .EAHeaderMain h1,
    .es .EAHeaderMain h1 {
        font-size: 66rem;
        line-height: 70rem;
    }

    .ru .EAHeaderModel,
    .mn .EAHeaderModel,
    .pt .EAHeaderModel,
    .es .EAHeaderModel {
        margin-left: -90rem;
    }

    .id .EAHeader {
        gap: 0rem
    }

    .id .EAHeaderMain {
        flex: 0 0 665rem;
    }
}

@media screen and (max-width: 996px) {
     .toolsBtn{
  width: 100%;
  gap: 10rem;
  box-sizing: border-box;
}
    .EAHeader {
        flex-direction: column;
        height: auto;
        gap: 0rem;
        padding: 0rem 32rem 80rem;
        text-align: center;
        overflow: hidden;
    }

    .EAHeaderMain {
        order: 2;
        flex: 1;
        margin-top: 0;
    }

    .EAHeaderMain h1 {
        margin-top: -80rem;
    }

    .EAHeaderModel {
        width: 810rem;
        height: auto;
        margin: -44px 0 0 -50rem;
    }

    .ar .EAHeaderModel {
        margin-left: unset;
        margin-right: -50rem;
    }

    .EADesc {
        margin-top: 16rem;
    }
}

.EAAnalyze {
    padding: 80rem 0 120rem;
    background: var(--ebc-basecolor-white-100);
}

.EAAnalyzeCardList {
    align-items: stretch;
    gap: 0rem;
    margin-bottom: 92rem;
    display: none!important;
}

@media screen and (min-width: 996px) {
    .EAAnalyzeCardList {
        background: linear-gradient(250deg,
                rgba(255, 255, 255, 0.8) 36.88%,
                #fff 100%);
        box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
        backdrop-filter: blur(10px);
        border-radius: var(--ebc-corner-radius-rc16);
        margin-top: -144rem;
    }

    .EAAnalyzeCard .splitLine {
        position: absolute;
        background: rgba(0, 0, 0, 0.08);
        width: 1px;
        height: 64rem;
    }

    .EAAnalyzeCard div {
        max-width: 240rem;
        margin-inline: auto;
    }

    .EAAnalyzeCard:nth-child(1) .splitLine {
        right: 0;
        top: 64rem;
    }

    .EAAnalyzeCard:nth-child(3) .splitLine {
        left: 0;
        top: 64rem;
    }
}

.EAAnalyzeCard {
    position: relative;
    border-radius: var(--ebc-corner-radius-rc16);
    /* background: var(--ebc-neutral-bg_b); */
    padding: 32rem;
    flex: 1;
    text-align: center;
    color: var(--ebc-text-secondary);
}

.EAAnalyzeCard img {
    width: 64rem;
    margin-bottom: 16rem;
}

.EAAnalyzeDesc {
    margin: 16rem 0 60rem;
    color: var(--ebc-text-secondary);
}

.EAAnalyzeToolsCardList {
    gap: 24rem;
}

.EAAnalyzeToolsCard {
    flex: 1;
}

.EAAnalyzeToolsImg {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 350rem;
    color: var(--ebc-text-secondary);
    text-align: center;
}

.EAAnalyzeToolsImgWithWordCenter {
    margin: 6.5rem 0;
    display: flex;
    gap: 0rem;
    justify-content: center;
}

.EAAnalyzeToolsImgCenterLeft {
    text-align: right;
    max-width: 70px;
}

.EAAnalyzeToolsImgCenterRight {
    text-align: left;
    max-width: 70px;
}



.ug .EAAnalyzeToolsImgCenterWordBottom,
.ru .EAAnalyzeToolsImgCenterWordBottom,
.mn .EAAnalyzeToolsImgCenterWordBottom,
.pt .EAAnalyzeToolsImgCenterWordBottom,
.id .EAAnalyzeToolsImgCenterWordBottom,
.vi .EAAnalyzeToolsImgCenterWordBottom,
.es .EAAnalyzeToolsImgCenterWordBottom,
.th .EAAnalyzeToolsImgCenterWordBottom,
.en .EAAnalyzeToolsImgCenterWordBottom {
    margin-top: 80rem;
}

.hi .EAAnalyzeToolsImgCenterLeft .EAAnalyzeToolsImgCenterWordBottom,
.ar .EAAnalyzeToolsImgCenterLeft .EAAnalyzeToolsImgCenterWordBottom,
.jp .EAAnalyzeToolsImgCenterLeft .EAAnalyzeToolsImgCenterWordBottom {
    margin-top: 78rem;
}

.jp .EAAnalyzeToolsImgCenterRight .EAAnalyzeToolsImgCenterWordBottom {
    margin-top: 50rem;
}

.EAAnalyzeToolsImgCenterWordTop {
    margin-top: 43rem;
}

.EAAnalyzeToolsImgCenterWordBottom {
    margin-top: 97rem;
}

.EAAnalyzeToolsCard:nth-child(1) .EAAnalyzeToolsImg img {
    width: 227rem;
    height: auto;
}

.EAAnalyzeToolsCard:nth-child(2) .EAAnalyzeToolsImg img {
    width: 320rem;
    height: auto;
}

.EAAnalyzeToolsCard:nth-child(3) .EAAnalyzeToolsImg img {
    width: 311rem;
    height: auto;
}

.EAAnalyzeToolsImg {
    border-radius: var(--ebc-corner-radius-rc16);
    background: #f7f7f7;
    margin-bottom: 24rem;
}

.EAAnalyzeToolsBtn {
    width: fit-content;
    min-width: 180rem;
    margin: 60rem auto 0;
    box-sizing: border-box;
}

@media (max-width: 996px) {
    .EAAnalyze {
        padding: 80rem 0rem 160rem;
        overflow: hidden;
    }

    .EAAnalyze h2,
    .EAAnalyze h3,
    .EAAnalyze .EAAnalyzeCardList {
        padding-inline: 32rem;
    }

    .EAAnalyzeCardList {
        flex-direction: column;
        gap: 32rem;
        margin-bottom: 160rem;
    }

    .EAAnalyzeCard {
        padding: 32rem;
        background: var(--ebc-neutral-bg_b);
        text-align: left;
        color: var(--ebc-text-secondary);

    }

    .EAAnalyzeCard img {
        width: 64rem;
        margin-bottom: 32rem;
    }


    .EAAnalyzeDesc {
        margin-bottom: 80rem;
    }

    .EAAnalyzeToolsCardList {
        gap: 0;
        justify-content: flex-start;
        /* flex-direction: column; */
    }

    .EAAnalyzeToolsImg {
        height: 560rem;
        margin-bottom: 32rem;
    }

    .EAAnalyzeToolsImgWithWordCenter {
        margin: 20rem 0;

    }

    .EAAnalyzeToolsCard {
        margin-inline: auto;
        flex: unset;
    }

    .EAAnalyzeToolsCard.swiper-slide {
        min-width: 100%;
        height: 100%;
        padding-inline: 32rem;
        box-sizing: border-box;
    }

    .EAAnalyzeToolsCard:nth-child(1) .EAAnalyzeToolsImg img {
        width: 384rem;
    }

    .ru .EAAnalyzeToolsCard:nth-child(1) .EAAnalyzeToolsImg img {
        width: 300rem;
    }

    .EAAnalyzeToolsCard:nth-child(2) .EAAnalyzeToolsImg img {
        width: 618rem;
    }

    .EAAnalyzeToolsCard:nth-child(3) .EAAnalyzeToolsImg img {
        width: 602rem;
    }

    .EAAnalyzeToolsImgCenterWordTop {
        margin-top: 66rem;
    }

    .EAAnalyzeToolsImgCenterWordBottom {
        margin-top: 166rem;
    }

    .ru .EAAnalyzeToolsImgCenterRight,
    .ru .EAAnalyzeToolsImgCenterLeft {
        max-width: 110px;
    }

    .ar .EAAnalyzeToolsImgCenterRight .EAAnalyzeToolsImgCenterWordBottom {
        margin-top: 118rem;
    }

    .ru .EAAnalyzeToolsImgCenterWordTop {
        margin-top: 30rem;
    }

    .ug .EAAnalyzeToolsImgCenterWordBottom,
    .pt .EAAnalyzeToolsImgCenterWordBottom,
    .id .EAAnalyzeToolsImgCenterWordBottom,
    .es .EAAnalyzeToolsImgCenterWordBottom,
    .vi .EAAnalyzeToolsImgCenterWordBottom,
    .en .EAAnalyzeToolsImgCenterWordBottom {
        margin-top: 100rem;
    }

    .kr .EAAnalyzeToolsImgCenterWordTop {
        white-space: nowrap;
    }

    .th .EAAnalyzeToolsImgCenterLeft .EAAnalyzeToolsImgCenterWordBottom {
        margin-top: 46rem;
    }

    .hi .EAAnalyzeToolsImgCenterLeft .EAAnalyzeToolsImgCenterWordBottom,
    .jp .EAAnalyzeToolsImgCenterLeft .EAAnalyzeToolsImgCenterWordBottom {
        margin-top: 106rem;
    }

    .EAAnalyze .EAAnalyzeToolsBtn {
        height: 80rem;
        margin-top: 80rem;
        font-size: 28rem;
        line-height: 80rem;
        box-sizing: border-box;
    }
}

.EAExecutor {
    padding: 120rem calc(50vw - 600rem);
    background: var(--ebc-basecolor-white-100);
}

.EAExecutorDesc {
    margin: 16rem 0 60rem;
    color: var(--ebc-text-secondary);
}

.EAExecutorIntro {
    gap: 60rem;
}

.EAExecutorIntro>img {
    width: 612rem;
    height: auto;
}

.EAExecutorIntroWord {
    flex: 1;
}

.EAExecutorIntroDesc {
    margin: 16rem 0 48rem;
    color: var(--ebc-text-secondary);
}

.EAExecutorIntroBtn {
    width: fit-content;
    min-width: 180rem;
    box-sizing: border-box;
}

@media (max-width: 996px) {
    .EAExecutor {
        padding: 160rem 30rem;
    }

    .EAExecutorIntro {
        flex-direction: column;
        gap: 48rem;
    }

    .EAExecutorDesc {
        margin-bottom: 80rem;
    }

    .EAExecutorIntro>img {
        width: 100%;
    }

    .EAExecutorIntroWord {
        text-align: center;
    }

    .EAExecutorIntroDesc {
        margin-bottom: 80rem;
    }

    .EAExecutorIntro .EAExecutorIntroBtn {
        height: 80rem;
        margin: 80rem auto 0;
        font-size: 28rem;
        line-height: 80rem;
    }

    .EAAnalyzeToolsCardPagenavition {
        margin-top: 32rem;
        gap: 8px;
    }

    .EATechListPagenavition {
        gap: 8px;
        margin-top: 48rem;
    }

    .EAAnalyzeToolsCardPagenavition div,
    .EATechListPagenavition div {
        border-radius: 999px;
        opacity: 0.5;
        background: var(---Active-BG_Disable, #EBADB2);
        width: 12px;
        height: 2px;
    }

    .EAAnalyzeToolsCardPagenavition div.active,
    .EATechListPagenavition div.active {
        opacity: 1;
        background: var(--ebc-basecolor-active-500);
        width: 24px;
    }
}


.EATech {
    padding: 120rem calc(50vw - 600rem);
    background: var(--ebc-neutral-bg_a);
}

.EATechDesc {
    margin: 16rem 0 60rem;
    color: var(--ebc-text-secondary);
}

.EATechList {
    gap: 48rem;
}

@media (min-width: 996px) {
    .EATechWordContainer {
        position: relative
    }

    /* 给进度条当参照 */
    .progress-bar {
        position: absolute;
        left: 0;
        top: 0;
        width: 3px;
        height: 0;
        background: #e60012;
        transition: height 6s linear;
        /* 6s 与 JS 里的时间保持一致 */
        pointer-events: none;
    }

    .EATechList {
        height: 400rem;
    }

    .ru .EATechList {
        height: 500rem;
    }
}

.EATechWordContainer {
    border-left: 2px solid var(--Neutral-Divider_Regular, rgba(0, 0, 0, 0.08));
    flex: 0 0 486rem;
}

.EATechWord {
    margin-bottom: 24rem;
    padding: 16rem 24rem 16rem 24rem;
    margin-left: -2px;
    position: relative;
}

.EATechWord:last-child {
    margin-bottom: 0;
}

.EATechWord.active {
    background: linear-gradient(to right,
            transparent 0px,
            /* 左边 1 px 透明 */
            transparent 1px,
            var(--ebc-neutral-bg_b) 1px,
            var(--ebc-neutral-bg_b) 100%);
    ;
    border-radius: 0 8px 8px 0;

}

@media (min-width: 996px) {
    .EATechWord::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 2px;
        height: 0%;
        background-color: var(--ebc-basecolor-active-500);
        z-index: 1;
    }

    .EATechWord.active::before {
        animation: borderProgress 6s linear forwards;
    }

    /* 4. 定义关键帧动画 */
    @keyframes borderProgress {
        from {
            height: 0%;
        }

        to {
            height: 100%;
        }
    }
}

.EATechWord.active .EATechWordTitle {
    color: var(--ebc-text-primary);
    font-weight: 700;
}

.EATechWord.active .EATechWordDesc {
    display: block;
}

.EATechWordTitle {
    color: var(--ebc-text-secondary);
}

.EATechWordDesc {
    margin-top: 8rem;
    color: var(--ebc-text-secondary);
    display: none;
}

.EATechImg {
    flex: 1;
    text-align: center;
}

.EATechImg img {
    display: none;
    width: 550rem;
    height: 330rem;
}

.EATechImg img.active {
    display: inline-block;
}

.EATechBtn {
    width: fit-content;
    min-width: 180rem;
    margin: 60rem auto 0;
    box-sizing: border-box;
}

@media (max-width: 996px) {
    .EATech {
        padding: 160rem 0rem;
        overflow: hidden;
    }

    .EATechDesc {
        margin-bottom: 80rem;
    }

    .EATechTitle,
    .EATechDesc,
    .EATechWordContainer {
        padding-inline: 32rem;
    }

    .EATechList {
        flex-direction: column;
        gap: 48rem;
    }

    .EATechWordContainer {
        order: 2;
    }

    .EATech .EATechBtn {
        height: 80rem;
        margin: 80rem auto 0;
        font-size: 28rem;
        line-height: 80rem;
    }

    .EATechWordContainer {
        border: 0;
        flex: 1;
    }

    .EATechWord {
        display: none;
        text-align: center;
    }

    .EATechWordDesc {
        margin-top: 16rem;
    }

    .EATechWord.active {
        display: block;
        background: none;
        border: 0;
        margin: 0;
        padding: 0;
    }

    .EATechImg {
        align-items: center;
    }

    .EATechImg img {
        display: block !important;
        width: 424rem;
        height: 256rem;

    }

    .EATechImg .swiper-slide-active {
        width: 570rem;
        height: 344rem;
    }

    .EATechImgSwiper {
        width: 100%;
    }
}

.EAOrderAnaly {
    background-color: var(--ebc-neutral-bg_b);
    padding: 120rem calc(50vw - 600rem);
}

.EAOrderAnaly h3 {
    margin: 16rem 0 60rem;
    color: var(--ebc-text-secondary);
}

.EAOrderAnalyCardList {
    gap: 24rem;
    margin: 60rem 0;
}

.EAOrderAnalyCard {
    flex: 1;
    border-radius: var(--ebc-corner-radius-rc16);
    border: 2px solid #FFF;
    background: var(--ebc-neutral-bg_a);
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
    padding-bottom: 24rem;
}

.EAOrderAnalyCard img {
    width: 100%;
    height: 208rem;
    margin-bottom: 16rem;
}

.EAOrderAnalyDesc {
    margin-top: 8rem;
    color: var(--ebc-text-secondary);
}

.EAOrderAnalyBtn {
    width: fit-content;
    min-width: 180rem;
    margin-inline: auto;
    box-sizing: border-box;
}

@media (max-width: 996px) {
    .EAOrderAnaly {
        padding: 160rem 32rem;
    }

    .EAOrderAnaly h3 {
        margin-bottom: 80rem;
    }

    .EAOrderAnalyCardList {
        margin: 80rem 0;
        flex-direction: column;
        gap: 42rem;
    }

    .EAOrderAnalyCard {
        width: 100%;
        padding-bottom: 42rem;
        border-radius: 14px;
    }

    .EAOrderAnalyCard img {
        margin-bottom: 28rem;
        height: 360rem;
    }

    .EAOrderAnalyDesc {
        margin-top: 14rem;
    }

    .EAOrderAnalyBtn {
        height: 80rem !important;
        font-size: 28rem !important;
    }
}

.EACalculate {
    padding: 120rem calc(50vw - 600rem);
    display: none;
}

.EACalculate h3 {
    color: var(--ebc-text-secondary);
    margin: 16rem 0 24rem;
}

.EACalculateBtn {
    gap: 5rem;
    color: var(--ebc-basecolor-active-500);
    font-size: 16rem;
    font-weight: 500;
    width: fit-content;
    margin: 0 auto 60rem
}
.commonQuestion{
    background-color: var(--ebc-neutral-bg_b)
}
.EACalculateList {
    flex-wrap: wrap;
    gap: 24rem;
}

.EACalculateItem {
    background: url('../assets/image/tools/EACalculateItemBg.svg') no-repeat right 4px top 4px / 144rem 80rem;
    border-radius: var(--ebc-corner-radius-rc08);
    background-color: var(--ebc-neutral-bg_a);
    padding: 24rem;
    flex: 0 0 376rem;
    min-height: 254rem;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border: 0.5px solid var(--Neutral-Stroke, rgba(0, 0, 0, 0.12));
    cursor: unset;
}

.EACalculateItem .EACalculateItemBtn {
    cursor: pointer;
}

.EACalculateItem img {
    margin-bottom: 32rem;
    width: 32rem;
    height: 32rem;
}

.EACalculateItemTitle {
    color: var(--ebc-text-primary);
}

.EACalculateItemDesc {
    margin: 8rem 0 auto;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    color: var(--ebc-text-secondary);
}

@media (max-width: 996px) {
    .EACalculate {
        padding: 160rem 32rem;
        background-color: var(--ebc-neutral-bg_b);
    }

    .EACalculate h3 {
        margin: 16rem 0 48rem;
    }

    .EACalculateBtn {
        gap: 8rem;
        font-size: 28rem;
        margin-bottom: 80rem;
    }

    .EACalculateItem {
        overflow: hidden;
        padding: 32rem;
        flex-direction: row;
        flex: 1 0 100%;
        min-height: 112rem;
        height: auto;
        background: url('../assets/image/tools/EACalculateItemBg.svg') no-repeat right 4px bottom 4px / 260rem 144rem;
        background-color: var(--ebc-neutral-bg_a);

    }

    .EACalculateItem .iconfont {
        font-size: 20px;
        line-height: 50rem;
        font-weight: 200;
        color: var(--ebc-text-secondary);
    }

    .EACalculateItem img {
        width: 48rem;
        height: 48rem;
        margin-bottom: 0;
    }

    .EACalculateItemTitle {
        margin: 0 auto 0 16rem;
    }

    .ar .EACalculateItemTitle {
        margin: 0 16rem 0 auto;
    }

    .EACalculateItemDesc,
    .EACalculateItemBtn {
        display: none;
    }

    .EACalculateItemBtn,
    .EACalculateItemDesc {
        display: none !important;
    }
}

.EAAdChart{
  background-color: #fff;
  padding-block: 120rem;
  text-align: center;
}

.EAAdChartDesc{
  margin-block: 16rem 60rem;
  color: var(--ebc-text-secondary);
}

.EAAdChartModel{
  width: 100%;
  height: auto;
}
.EAAdChartList{
  margin-block: 60rem;
  gap: 10rem;
}
.EAAdChartList>div{
  flex: 1;
}
.EAAdChartList img{
  width: 40rem;
  height: 40rem;
}
.EAAdChartListTitle{
  margin-block: 8rem;
}
.EAAdChartList>div div:last-child{
  color: var(--ebc-text-secondary);
}
.EAAdChartBtn{
  min-width: 180rem;
  width: fit-content;
  margin-inline: auto;
}
.EAAnalyze{
  background: var(--ebc-neutral-bg_b);
}
.EAOrderAnaly {
  background: var(--ebc-neutral-bg_a);
}
.EATech{
  background: linear-gradient(180deg, #F7F7F7 0%, #FFF 100%);
}
@media (max-width: 996px) {
  .EAAdChart{
  padding: 160rem 32rem;
}
  .zh .EAAdChart .EAAdChartDesc {
    white-space: nowrap;
  }
.EAAdChartDesc{
  margin-bottom: 80rem;
}

.EAAdChartList{
  margin-block: 64rem;
  gap: 28rem;
  flex-direction: column;
  justify-content: center;
}
.EAAdChartList img{
  width: 56rem;
  height: 56rem;
}
.EAAdChartListTitle{
  margin-block: 16rem;
}
.EAAdChart .EAAdChartBtn{
  min-width: 210rem;
  height: 80rem;
  font-size: 28rem;
  line-height: 28rem;
}
}
</style>
